import React from "react";
import FeatherIcon from "feather-icons-react";
import { getBranding } from "../../theme/branding";

const FooterView = () => {
  const brand = getBranding();

  return (
    <footer className="ev-footer">
      <div className="ev-footer__inner">
        <span>© {new Date().getFullYear()} <strong>{brand.displayName}</strong> · {brand.moduleLabel}
        <span className="ms-5">
          <FeatherIcon icon="heart" size={13} className="text-danger mx-1" />
          <a className="text-decoration-none ms-1" href="https://evivesoma.net" target="_blank" rel="noreferrer">EviveSoma</a>
          <span className="mx-1">·</span>
          <a className="text-decoration-none" href="https://evivedigital.net" target="_blank" rel="noreferrer">EviveDigital</a>
        </span>
        </span>
      </div>
    </footer>
  );
};

export default FooterView;
